import React, { useState, useEffect } from 'react';
import { 
  Button, Input, Spin, Select, Space, Tag, Empty, Typography, 
  ConfigProvider, Table, Modal, InputNumber, Divider, List, Card, Row, Col
} from 'antd';
import { 
  FaSearch, FaMinus, FaBoxOpen, FaSave, FaTrash 
} from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api';
import formatarValor from '../formatarValor';

const { Title } = Typography;

const BaixaEstoque = () => {
  const [produtos, setProdutos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [searchModalText, setSearchModalText] = useState('');
  const [quantidadesBaixadas, setQuantidadesBaixadas] = useState({});
  const [quantidadesSalvas, setQuantidadesSalvas] = useState({});
  const [salvandoProduto, setSalvandoProduto] = useState(null);
  const [produtosBaixados, setProdutosBaixados] = useState([]);

  const primaryColor = 'rgb(249, 130, 68)';
  const secondaryColor = 'rgb(247, 72, 115)';
  const gradient = `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`;

  useEffect(() => { fetchData(); }, []);
  useEffect(() => { if (isModalVisible) fetchProdutosBaixados(); }, [isModalVisible]);


  useEffect(() => {
     document.title = "Baixa";
   
  }, []);




  const fetchData = async () => {
    try {
      setLoading(true);
      const [produtosData, categoriasData] = await Promise.all([
        Api.ListProduto(),
        Api.ListCategoria()
      ]);
      const produtosFormatados = produtosData.map(p => ({ 
        id: p.id,
        descricao: p.descricao,
        preco: parseFloat(p.preco) || 0,
        status: p.status,
        quantidade: parseInt(p.qtd) || 0,
        id_categoria: p.id_categoria,
        key: p.id
      }));
      setProdutos(produtosFormatados);
      setCategorias(categoriasData);
    } catch (error) {
      toast.error('Erro ao carregar dados: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchProdutosBaixados = async () => {
    try {

       const dados={cod:'BAI'};
      const estoqueData = await Api.ListEstoque(dados);
      const produtosBaixadosFormatados = estoqueData.map(item => ({
        id: item.id,
        produto: item.produto,
        quantidade: parseInt(item.qtd) || 0,
        key: item.id
      }));
      setProdutosBaixados(produtosBaixadosFormatados);
    } catch (error) {
      toast.error('Erro ao carregar produtos baixados: ' + error.message);
    }
  };

  const removerProdutoBaixado = async (id) => {
    try {
      const dados={id:id};
      await Api.DeleteEstoque(dados);
      toast.success('Produto removido com sucesso!');
      fetchProdutosBaixados();
    } catch (error) {
      toast.error('Erro ao remover produto: ' + error.message);
    }
  };

  const filteredProdutos = produtos.filter(produto => {
    const matchesSearch = produto.descricao.toLowerCase().includes(searchText.toLowerCase());
    const matchesCategory = selectedCategory ? produto.id_categoria === selectedCategory : true;
    const matchesStatus = selectedStatus ? produto.status === selectedStatus : true;
    return matchesSearch && matchesCategory && matchesStatus;
  });

  const filteredModalProdutos = produtos.filter(produto => 
    produto.descricao.toLowerCase().includes(searchModalText.toLowerCase())
  );

  const abrirModalBaixa = () => {
    setQuantidadesBaixadas({});
    setQuantidadesSalvas({});
    setSearchModalText('');
    setIsModalVisible(true);
  };

  const handleQuantidadeChange = (produtoId, quantidade, max) => {
    if (quantidade > max) {
      toast.warning(`A quantidade não pode exceder o estoque atual (${max}).`);
      quantidade = max;
    }
    setQuantidadesBaixadas(prev => ({
      ...prev,
      [produtoId]: quantidade || 0
    }));
  };

  const salvarQuantidadeProduto = async (produtoId, estoqueAtual) => {
    const quantidade = quantidadesBaixadas[produtoId];
    if (!quantidade || quantidade <= 0) {
      toast.warning('Informe uma quantidade válida!');
      return;
    }
    if (quantidade > estoqueAtual) {
      toast.warning(`Quantidade maior que o estoque disponível (${estoqueAtual}).`);
      return;
    }
    try {
      setSalvandoProduto(produtoId);
      const formData = new FormData();
      formData.append('id_produto', produtoId);
      formData.append('qtd', quantidade.toString());
      formData.append('cod', 'BAI');

      const response = await Api.AddEstoque(formData);


      if (response.success) {
        toast.success('Baixa registrada com sucesso!');
        setQuantidadesSalvas(prev => ({ ...prev, [produtoId]: quantidade }));
        setQuantidadesBaixadas(prev => ({ ...prev, [produtoId]: 0 }));
        await fetchProdutosBaixados();
      } else {
        toast.error('Erro ao registrar baixa.');
      }
    } catch (error) {
      toast.error('Erro ao salvar: ' + error.message);
    } finally {
      setSalvandoProduto(null);
    }
  };

  const finalizarBaixaEstoque = async () => {
    try {
      setModalLoading(true);
      const response = await Api.AlterBaixa();
      const data = response?.data || response;
      if (data.success) {
        toast.success("Baixa de estoque concluída com sucesso!");
        await fetchData();
        setIsModalVisible(false);
        setQuantidadesBaixadas({});
        setQuantidadesSalvas({});
      } else {
        toast.error("Erro ao concluir baixa!");
      }
    } catch (error) {
      toast.error("Erro ao finalizar: " + error.message);
    } finally {
      setModalLoading(false);
    }
  };

  const columnsModal = [
    {
      title: 'Produto',
      dataIndex: 'descricao',
      key: 'descricao',
      width: '40%',
    },
    {
      title: 'Estoque Atual',
      dataIndex: 'quantidade',
      key: 'quantidade',
      width: 120,
      render: (quantidade) => (
        <Tag color={quantidade > 10 ? 'green' : quantidade > 0 ? 'orange' : 'red'}>
          {parseInt(quantidade) || 0}
        </Tag>
      ),
    },
    {
      title: 'Quantidade a Baixar',
      key: 'baixar',
      width: 280,
      render: (_, record) => (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <InputNumber
            min={0}
            max={record.quantidade}
            value={quantidadesBaixadas[record.id]}
            onChange={(value) => handleQuantidadeChange(record.id, value, record.quantidade)}
            style={{ flex: 1, borderRadius: 6 }}
            placeholder="0"
            disabled={salvandoProduto === record.id || record.quantidade <= 0}
          />
          <Button
            type="primary"
            icon={<FaMinus />}
            size="small"
            loading={salvandoProduto === record.id}
            onClick={() => salvarQuantidadeProduto(record.id, record.quantidade)}
            disabled={!quantidadesBaixadas[record.id] || quantidadesBaixadas[record.id] <= 0}
            style={{
              background: gradient,
              border: 'none',
              borderRadius: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 32,
              height: 32
            }}
            title="Registrar baixa"
          />
        </div>
      ),
    },
    {
      title: 'Qtd. Baixada',
      key: 'salva',
      width: 100,
      render: (_, record) => {
        const qtdSalva = quantidadesSalvas[record.id];
        return qtdSalva ? (
          <Tag color="red" style={{ fontWeight: 'bold' }}>
            -{qtdSalva}
          </Tag>
        ) : (
          <span style={{ color: 'rgba(0,0,0,0.3)' }}>-</span>
        );
      },
    },
  ];

  return (
    <ConfigProvider theme={{ token: { colorPrimary: primaryColor, borderRadius: 8 } }}>
      <div style={{ padding: 24, background: '#f8f9fa', minHeight: '100vh' }}>
        <ToastContainer position="top-right" />

        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24, alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <Title level={2} style={{ margin: 0, background: gradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            BAIXA DE ESTOQUE
          </Title>

          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
            <Input
              placeholder="Pesquisar produtos..."
              prefix={<FaSearch style={{ color: 'rgba(0,0,0,0.3)' }} />}
              value={searchText}
              onChange={(e) => { setSearchText(e.target.value); setCurrentPage(1); }}
              style={{ width: 250, borderRadius: 8, border: '1px solid rgba(0,0,0,0.1)' }}
            />

            <Select
              placeholder="Filtrar por categoria"
              options={categorias.map(c => ({ value: c.id, label: c.descricao }))}
              value={selectedCategory}
              onChange={(value) => { setSelectedCategory(value); setCurrentPage(1); }}
              style={{ width: 180, borderRadius: 8 }}
              allowClear
            />

            <Select
              placeholder="Filtrar por status"
              options={[
                { value: 'DISPONÍVEL', label: 'Disponível' },
                { value: 'INDISPONÍVEL', label: 'Indisponível' }
              ]}
              value={selectedStatus}
              onChange={(value) => { setSelectedStatus(value); setCurrentPage(1); }}
              style={{ width: 150, borderRadius: 8 }}
              allowClear
            />

            <Button 
              type="primary"
              icon={<FaMinus />}
              onClick={abrirModalBaixa}
              style={{ 
                background: gradient,
                border: 'none',
                borderRadius: 8,
                boxShadow: '0 4px 12px rgba(247, 72, 115, 0.3)',
                height: 40,
                display: 'flex',
                alignItems: 'center',
                gap: 8
              }}
            >
              Registrar Baixa
            </Button>
          </div>
        </div>

        <Spin spinning={loading}>
          {filteredProdutos.length > 0 ? (
            <Table
              scroll={{ x: true }}
              columns={[
                { title: 'Descrição', dataIndex: 'descricao', key: 'descricao' },
                { title: 'Preço', dataIndex: 'preco', key: 'preco', render: (p) => formatarValor(p) },
                { title: 'Estoque Atual', dataIndex: 'quantidade', key: 'quantidade', render: (q) => <Tag color={q > 0 ? 'green' : 'red'}>{q}</Tag> },
              ]}
              dataSource={filteredProdutos}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: filteredProdutos.length,
                onChange: (page) => setCurrentPage(page),
                showSizeChanger: false,
              }}
              rowKey="id"
            />
          ) : (
            <Empty description="Nenhum produto encontrado" />
          )}
        </Spin>

        <Modal
          forceRender
          title={
            <Space style={{ fontSize: '18px', fontWeight: 600 }}>
              <FaBoxOpen style={{ color: primaryColor }} />
              <span style={{
                background: gradient,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Registrar Baixa de Estoque
              </span>
            </Space>
          }
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          width={1200}
          footer={null}
          destroyOnClose
        >
          <div style={{ marginTop: 16 }}>
            <Input
              placeholder="Pesquisar produtos..."
              prefix={<FaSearch style={{ color: 'rgba(0,0,0,0.3)' }} />}
              value={searchModalText}
              onChange={(e) => setSearchModalText(e.target.value)}
              style={{ marginBottom: 16, borderRadius: 8 }}
            />

            <Row gutter={[16, 16]}>
              <Col xs={24} lg={12}>
                <Card title="Todos os Produtos" size="small">
                  <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                    <Table scroll={{ x: true }} columns={columnsModal} dataSource={filteredModalProdutos} pagination={false} rowKey="id" size="small" />
                  </div>
                </Card>
              </Col>

              <Col xs={24} lg={12}>
                <Card title="Produtos Baixados" size="small">
                  <div style={{ maxHeight: '350px', overflowY: 'auto', padding: '8px' }}>
                    {produtosBaixados.length > 0 ? (
                      <List
                        dataSource={produtosBaixados}
                        renderItem={(item) => (
                          <List.Item
                            actions={[
                              <Button
                                type="text"
                                danger
                                icon={<FaTrash />}
                                size="small"
                                onClick={() => removerProdutoBaixado(item.id)}
                              />
                            ]}
                          >
                            <List.Item.Meta
                              title={item.produto}
                              description={<Space><span>Quantidade:</span><Tag color="red">-{item.quantidade}</Tag></Space>}
                            />
                          </List.Item>
                        )}
                      />
                    ) : (
                      <Empty description="Nenhuma baixa registrada" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )}
                  </div>
                </Card>
              </Col>
            </Row>

            <Divider />

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
              <Button onClick={() => setIsModalVisible(false)}>Cancelar</Button>
              <Button
                type="primary"
                icon={<FaSave />}
                loading={modalLoading}
                onClick={finalizarBaixaEstoque}
                disabled={produtosBaixados.length === 0}
                style={{ background: gradient, border: 'none' }}
              >
                Finalizar Baixa de Estoque
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </ConfigProvider>
  );
};

export default BaixaEstoque;
